export const about = {
  backToHome: "Retour à l'accueil",
  title: "À Propos de Novaventure",
  whoWeAre: {
    title: "Qui Nous Sommes",
    paragraph1: "Novaventure est un cabinet de conseil axé sur les données, spécialisé dans la transformation de données complexes en stratégies commerciales exploitables. Basés à Blaasveld Willebroek, Belgique, nous aidons les organisations à libérer tout le potentiel de leurs données pour stimuler la croissance, optimiser les opérations et prendre des décisions éclairées.",
    paragraph2: "Notre équipe d'analystes et de stratèges expérimentés combine une connaissance approfondie du secteur avec des outils analytiques de pointe pour fournir des informations qui comptent. Nous croyons que les données ne sont pas seulement des chiffres—c'est la base d'un avantage stratégique dans le paysage concurrentiel d'aujourd'hui."
  },
  ourMission: {
    title: "Notre Mission",
    description: "Notre mission est de donner aux entreprises l'intelligence dont elles ont besoin pour prospérer. Nous transformons les données brutes en informations stratégiques, permettant à nos clients de prendre des décisions en toute confiance, d'identifier de nouvelles opportunités et de rester en avance sur les tendances du marché. Nous nous engageons à fournir l'excellence, l'intégrité et des résultats mesurables dans tout ce que nous faisons."
  },
  whatWeDo: {
    title: "Ce Que Nous Faisons",
    intro: "Chez Novaventure, nous offrons une suite complète de services axés sur les données conçus pour relever les défis uniques des entreprises modernes:",
    services: {
      marketAnalysis: {
        title: "Analyse de Marché:",
        description: "Recherche approfondie sur les tendances du marché, les paysages concurrentiels et le comportement des clients pour éclairer la planification stratégique."
      },
      leadEnablement: {
        title: "Activation de Leads:",
        description: "Stratégies basées sur les données pour identifier, qualifier et convertir des prospects de grande valeur en clients fidèles."
      },
      businessIntelligence: {
        title: "Intelligence d'Affaires:",
        description: "Tableaux de bord personnalisés et solutions de reporting qui offrent une visibilité en temps réel sur les indicateurs de performance clés."
      },
      strategicSupport: {
        title: "Support Stratégique:",
        description: "Services de conseil continus pour vous aider à naviguer dans les défis commerciaux complexes et à capitaliser sur les opportunités émergentes."
      }
    }
  },
  ourApproach: {
    title: "Notre Approche",
    intro: "Nous croyons en une approche collaborative et centrée sur le client. Chaque engagement commence par la compréhension de votre contexte commercial unique, de vos défis et de vos objectifs. À partir de là, nous:",
    steps: {
      listen: {
        title: "Écouter:",
        description: "Nous prenons le temps de comprendre votre entreprise, votre secteur et vos objectifs."
      },
      analyze: {
        title: "Analyser:",
        description: "Nous plongeons profondément dans vos données, découvrant des modèles, des tendances et des opportunités."
      },
      strategize: {
        title: "Stratégiser:",
        description: "Nous développons des recommandations sur mesure basées sur des preuves solides et les meilleures pratiques de l'industrie."
      },
      execute: {
        title: "Exécuter:",
        description: "Nous travaillons à vos côtés pour mettre en œuvre des solutions et suivre les résultats."
      },
      optimize: {
        title: "Optimiser:",
        description: "Nous affinons continuellement les stratégies pour assurer un succès durable."
      }
    }
  },
  whyChoose: {
    title: "Pourquoi Choisir Novaventure",
    intro: "Dans un monde débordant de données, le véritable défi est de transformer l'information en perspicacité. C'est là que nous excellons. Voici ce qui nous distingue:",
    reasons: {
      expertise: {
        title: "Expertise:",
        description: "Notre équipe apporte des années d'expérience dans plusieurs secteurs et disciplines analytiques."
      },
      customization: {
        title: "Personnalisation:",
        description: "Nous ne croyons pas aux solutions universelles. Chaque stratégie est adaptée à vos besoins spécifiques."
      },
      resultsDriven: {
        title: "Axé sur les Résultats:",
        description: "Nous nous concentrons sur les résultats qui comptent—croissance des revenus, économies de coûts et avantage concurrentiel."
      },
      partnership: {
        title: "Partenariat:",
        description: "Nous nous considérons comme une extension de votre équipe, engagés dans votre succès à long terme."
      }
    }
  },
  ourValues: {
    title: "Nos Valeurs",
    values: {
      integrity: {
        title: "Intégrité",
        description: "Nous opérons avec transparence et honnêteté dans toutes nos relations clients."
      },
      excellence: {
        title: "Excellence",
        description: "Nous visons les normes les plus élevées dans chaque projet que nous entreprenons."
      },
      innovation: {
        title: "Innovation",
        description: "Nous explorons continuellement de nouvelles méthodologies et technologies pour fournir de meilleurs résultats."
      },
      collaboration: {
        title: "Collaboration",
        description: "Nous croyons en la collaboration avec nos clients pour atteindre un succès partagé."
      }
    }
  },
  getInTouch: {
    title: "Contactez-Nous",
    intro: "Prêt à transformer vos données en stratégie? Nous aimerions avoir de vos nouvelles. Que vous ayez un projet spécifique en tête ou que vous souhaitiez simplement explorer comment nous pouvons vous aider, notre équipe est là pour vous assister.",
    contactInfo: "Informations de Contact",
    phone: "Téléphone",
    email: "Email",
    address: "Adresse"
  }
};
